import { render, staticRenderFns } from "./UpdateTrigger.vue?vue&type=template&id=b1384c3c"
import script from "./UpdateTrigger.vue?vue&type=script&lang=js"
export * from "./UpdateTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports